import { api } from 'api';
import { ClaimRow, ExhibitPost } from 'api/endpoints';
import { Claim } from 'api/endpoints/exhibits';
import { GraphQlApolloClient } from 'api/graphql';
import { isEmpty } from 'lodash';
import { sortByNameAsc } from 'utils/agGridHotchocolate/const';
import { AgGridFilter } from 'utils/agGridHotchocolate/types';
import { ExhibitFields } from '../typesExhibitExporter';
import { getClaimsBy, getClaimsByColumnSet } from './graphQlExhibitUtils';

export const apiExhibitExport = {
  getChildClaims: async (actionNameId: number | undefined) => {
    if (!actionNameId) return [];
    const result = await api.exhibits.getChildClaims(actionNameId);
    return result ?? [];
  },

  getClaimsByActionName: async (
    client: GraphQlApolloClient,
    actionNameId: number | undefined,
  ) => {
    if (!actionNameId) return [];

    const filterModel: AgGridFilter = {
      filterType: 'number',
      type: 'equals',
      filter: actionNameId,
    };

    const result = await getClaimsBy(
      client,
      'actionNameId',
      filterModel,
      sortByNameAsc,
    );
    return result;
  },

  loadClaimRowData: async (
    client: GraphQlApolloClient,
    claims: Claim[] | undefined,
  ) => {
    const claimsIds = claims?.map((c) => c.claimId);
    if (!claimsIds || isEmpty(claimsIds)) return [];

    const result = await getClaimsByColumnSet(client, claimsIds, 'id');
    return result;
  },

  saveToHistoryItem: (value: ExhibitFields, claims: ClaimRow[]) => {
    const valueToSave: ExhibitPost = {
      exhibitNumber: value.exhibitNumber,
      objectionBasis: value.objectionBasis,
      actionNameId: value.resolutionActionNameId ?? 0,
      claims: claims.map((r) => r.id),
      structureHeaderOptions: value.structure.header.map((r) => +r),
      structureFooterOptions: value.structure.footer.map((r) => +r),
      globalFootnotes: value.footer.map((r) => ({
        footnote: r.text,
        footnoteAppearOptionId: +r.optionId,
      })),
      referencingClaimFootnotes: [],
    };

    return api.exhibits.create(valueToSave);
  },
};
